import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreCommonModule } from '@core/common.module';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';

import { NavbarComponent } from 'app/layout/components/navbar/navbar.component';
import { NavbarBookmarkComponent } from 'app/layout/components/navbar/navbar-bookmark/navbar-bookmark.component';
import { NavbarSearchComponent } from 'app/layout/components/navbar/navbar-search/navbar-search.component';

import { NavbarNotificationComponent } from 'app/layout/components/navbar/navbar-notification/navbar-notification.component';
import { SchoolSwitcherComponent } from 'app/layout/components/navbar/school-switcher/school-switcher.component';
import { NotificationService } from '@core/services/notification.service';
import {PaymentsModule} from "../../../main/pages/payment-page/payments.module";
import { SharedModule } from 'app/shared/shared.module';
import { QuizModule } from 'app/main/quiz/quiz.module';

@NgModule({
  declarations: [NavbarComponent, NavbarSearchComponent, NavbarBookmarkComponent, NavbarNotificationComponent, SchoolSwitcherComponent],
  imports: [RouterModule, NgbModule, CoreCommonModule, CoreTouchspinModule, PaymentsModule, SharedModule, QuizModule],
  providers: [NotificationService],
  exports: [NavbarComponent]
})
export class NavbarModule {}
